module.exports = __webpack_public_path__ + "static/media/rachel.e5c249da.jpg";